'use strict';

function Permission (permissions) {
  this.permissions = permissions;
}

Permission.IS_EDIT = 'edit';
Permission.IS_DELETE = 'delete';
Permission.IS_TO_ARCHIVE = 'toArchive';
Permission.IS_DELETE_FROM_SOLD = 'deleteFromSold';
Permission.IS_RESET_COORDINATES = 'resetCoordinates';
Permission.IS_GO_PROFILE = 'manageUser';
Permission.IS_RESET_XML_IMAGE = 'resetXmlImage';

Permission.prototype.isAllow = function (permission) {
  return this.permissions.get(permission, false);
};

export default Permission;



// WEBPACK FOOTER //
// ./src/classes/common/permission.js